export default __webpack_public_path__ + "static/media/028-trumpet.bfd6c81c.svg";